<div class="forms-terms">
    <div class="forms-terms__inner">
        <span class="forms-terms__label">{{label}} </span>
        <span (click)="handleTermsAndConditionsClick($event)" class="forms-terms__link">{{terms}}</span>
        &
        <span (click)="handlePrivacyPolicyClick($event)" class="forms-terms__link">{{privacyPolicy}}</span>
    </div>
</div>